var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80001 14.9333H2.75693C2.11693 14.9333 1.60001 14.4634 1.60001 13.8699V3.7301C1.60001 3.13655 2.11693 2.66666 2.75693 2.66666H4.80001V3.6559H2.75693C2.65847 3.6559 2.60924 3.70537 2.58462 3.7301V13.8452C2.58462 13.8699 2.65847 13.9193 2.75693 13.9193H4.80001V14.9333Z",
    fill: "rgba(0, 0, 0, 0.54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3863 1.06668H4.2137C3.64505 1.06668 3.20001 1.53716 3.20001 2.10668V13.9181C3.20001 14.4876 3.66977 14.9333 4.2137 14.9333H13.3863C13.955 14.9333 14.4 14.4629 14.4 13.9181V2.08192C14.4 1.53716 13.955 1.06668 13.3863 1.06668ZM9.05961 10.2038H5.74659C5.47463 10.2038 5.25211 9.98097 5.25211 9.70859C5.25211 9.43621 5.47463 9.21335 5.74659 9.21335H9.05961C9.33158 9.21335 9.5541 9.43621 9.5541 9.70859C9.5541 9.98097 9.33158 10.2038 9.05961 10.2038ZM11.8534 7.38097H5.74659C5.47463 7.38097 5.25211 7.15811 5.25211 6.88573C5.25211 6.61335 5.47463 6.39049 5.74659 6.39049H11.8534C12.1254 6.39049 12.3479 6.61335 12.3479 6.88573C12.3479 7.15811 12.1254 7.38097 11.8534 7.38097ZM11.8534 4.55811H5.74659C5.47463 4.55811 5.25211 4.33525 5.25211 4.06287C5.25211 3.79049 5.47463 3.56763 5.74659 3.56763H11.8534C12.1254 3.56763 12.3479 3.79049 12.3479 4.06287C12.3479 4.33525 12.1254 4.55811 11.8534 4.55811Z",
    fill: "rgba(0, 0, 0, 0.54)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.83e0fbb3b806b55b63626b8b8056850f.svg";
export { ForwardRef as ReactComponent };